import React from 'react';
import { Route } from 'react-router-dom';
import { AdminRoute, SuperadminRoute } from '@/routes/guards';
import { lazyWithRetry } from '@/routes/utils';
import { AdminLayout } from '@/features/admin/components/layout/AdminLayout';

const AdminOverview = lazyWithRetry(() => import('@/pages/admin/Overview'));
const AdminUsers = lazyWithRetry(() => import('@/pages/admin/Users'));
const AdminProjects = lazyWithRetry(() => import('@/pages/admin/Projects'));
const AdminSubscriptions = lazyWithRetry(() => import('@/pages/admin/Subscriptions'));
const AdminMessages = lazyWithRetry(() => import('@/pages/admin/Messages'));
const AdminConsultations = lazyWithRetry(() => import('@/pages/admin/Consultations'));
const AdminActivity = lazyWithRetry(() => import('@/pages/admin/Activity'));
const AdminUploadErrors = lazyWithRetry(() => import('@/pages/admin/UploadErrors'));
const AdminLoginJournal = lazyWithRetry(() => import('@/pages/admin/LoginJournal'));
const AdminUserSessions = lazyWithRetry(() => import('@/pages/admin/UserSessions'));
const AdminMyKeys = lazyWithRetry(() => import('@/pages/admin/MyKeys'));
const AdminApiKeys = lazyWithRetry(() => import('@/pages/admin/ApiKeys'));
const AdminPeople = lazyWithRetry(() => import('@/pages/admin/People'));
const AdminUsage = lazyWithRetry(() => import('@/pages/admin/Usage'));

export const adminRoutes = (
  <>
    <Route
      path="/admin"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminOverview />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/users"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminUsers />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/projects"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminProjects />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/subscriptions"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminSubscriptions />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/messages"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminMessages />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/consultations"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminConsultations />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/activity"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminActivity />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/upload-errors"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminUploadErrors />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/login-journal"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminLoginJournal />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/user-sessions"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminUserSessions />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/keys"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminMyKeys />
          </AdminLayout>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/api-keys"
      element={
        <AdminRoute>
          <SuperadminRoute>
            <AdminLayout>
              <AdminApiKeys />
            </AdminLayout>
          </SuperadminRoute>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/people"
      element={
        <AdminRoute>
          <SuperadminRoute>
            <AdminLayout>
              <AdminPeople />
            </AdminLayout>
          </SuperadminRoute>
        </AdminRoute>
      }
    />
    <Route
      path="/admin/usage"
      element={
        <AdminRoute>
          <AdminLayout>
            <AdminUsage />
          </AdminLayout>
        </AdminRoute>
      }
    />
  </>
);
